import { HeaderMiniCartDropMenu } from '@/components/content/Header/parts/MiniCartDropMenu';
import { headerItemStackSX } from '@/components/content/Header/styles/itemStack';
import {
	headerMiniCartContainerSX,
	iconCountCartSX,
	numberCountCartSX,
} from '@/components/content/Header/styles/miniCart/container';
import { useLockBodyScroll } from '@/utils/lockBodyScroll';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { Stack, Tooltip, Typography } from '@mui/material';
import { FC, MouseEventHandler, useEffect } from 'react';

type Props = {
	open: boolean;
	count: number;
	fromLocal: boolean;
	handleToolTip: (action: string) => () => void;
	onMouseEnter: MouseEventHandler<HTMLDivElement>;
	onOpenFreeShippingActivatedPopup: (resumeCheckout: () => void) => Promise<boolean>;
};

export const HeaderMiniCartDesktop: FC<Props> = ({
	open,
	count,
	fromLocal,
	handleToolTip,
	onMouseEnter,
	onOpenFreeShippingActivatedPopup,
}) => {
	useEffect(() => {
		if (!open) return;

		const syncMiniCartTop = () => {
			const topEl = document.getElementById('header-top');
			const bottomEl = document.getElementById('header-bottom');
			const headerEl = document.getElementById('header');
			const topY = topEl ? Math.max(topEl.getBoundingClientRect().top, 0) : 0;
			const bottomY = bottomEl ? Math.max(bottomEl.getBoundingClientRect().top, 0) : 0;
			const headerHeight = headerEl ? Math.max(headerEl.getBoundingClientRect().height, 66) : 66;
			const headerSize = Math.max(bottomY - topY, headerHeight);

			document.documentElement.style.setProperty('--mini-cart-top', `${headerSize}px`);
		};

		syncMiniCartTop();
		window.addEventListener('resize', syncMiniCartTop);

		return () => {
			window.removeEventListener('resize', syncMiniCartTop);
		};
	}, [open]);

	useLockBodyScroll(open);

	return (
		<Stack sx={headerMiniCartContainerSX}>
			<Tooltip
				placement="bottom"
				open={open}
				onClose={handleToolTip('close')}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				TransitionProps={{ timeout: 0 }}
				PopperProps={{
					sx: {
						position: 'fixed !important',
						width: '100vw',
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						opacity: '1',
						height: 'calc(100vh - var(--mini-cart-top, 66px))',
						top: 'var(--mini-cart-top, 66px) !important',
						left: '0 !important',
						transform: 'none !important',
					},
				}}
				componentsProps={{
					transition: {
						sx: {
							backgroundColor: 'transparent',
							color: '#2C2C2C',
							float: 'right',
						},
					} as any,
				}}
				title={
					open ? (
						<HeaderMiniCartDropMenu
							fromLocal={fromLocal}
							onClose={handleToolTip('close')}
							onOpenFreeShippingActivatedPopup={onOpenFreeShippingActivatedPopup}
						/>
					) : null
				}
			>
				<Stack
					id="MiniShoppingCart"
					alignItems="center"
					onClick={onMouseEnter}
					sx={headerItemStackSX}
				>
					<Stack sx={{ alignItems: 'center', paddingTop: '0px' }}>
						{count > 0 ? (
							<Typography sx={numberCountCartSX({ isMobile: false })}>{count}</Typography>
						) : null}
						<ShoppingCartIcon sx={iconCountCartSX({ isMobile: false, isItemsCount: count > 0 })} />
					</Stack>
				</Stack>
			</Tooltip>
		</Stack>
	);
};
